export default __webpack_public_path__ + "static/media/icon_dollar_active.059213a3.svg";